// import service from "../services/vehicle-types-service";
import Service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
  aggregatedData: [],
  analyticsData: {},
  //
};

const mutations = {
  SET_META(state, payload) {
    // if (data.meta) {
    //   state.meta.page = data.meta.current_page;
    //   state.meta.itemsPerPage = data.meta.per_page;
    //   state.meta.lastPage = data.meta.last_page;
    //   state.meta.totalItems = data.meta.total;
    // }
    state.meta.page = 1;
    state.meta.itemsPerPage = payload.length;
    state.meta.lastPage = 1;
    state.meta.totalItems = payload.length;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_AGGREGATED_DATA(state, payload) {
    state.aggregatedData = payload;
  },
  SET_ANALYTICS_DATA(state, payload) {
    state.analyticsData = payload;
  },
};

const actions = {
  list: async (store, params) => {
    store.state.loading = true;

    await Service.get(`bookings/user-analytics/kpis`, params).then((data) => {
      store.commit("SET_AGGREGATED_DATA", data.body);
    });
    await Service.get(`bookings/user-analytics/users`, params).then((data) => {
      store.commit("SET_META", data.body);
      store.commit("SET_LIST", data.body);
    });
    await Service.get(`bookings/user-analytics/analytics`, params).then(
      (data) => {
        store.commit("SET_ANALYTICS_DATA", data.body);
      }
    );

    store.state.loading = false;
  },

  export: async (store, params) => {
    store.state.loading = true;
    await Service.get(`bookings/user-analytics/export`, params)
      .then((data) => {
        window.open(data.body[params.type], "_blank");
      })
      .finally(() => store.state);
  },

  //
  profile: async (store, params) => {
    store.state.loading = true;
    return await Service.get(
      `bookings/user-analytics/profile/${params.id}`,
      params
    )
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  sessions: async (store, params) => {
    store.state.loading = true;
    return await Service.get(
      `bookings/user-analytics/sessions/${params.id}`,
      params
    )
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  sessionDetails: async (store, params) => {
    store.state.loading = true;
    return await Service.get(
      `bookings/user-analytics/session-detail/${params.id}`,
      params
    )
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
  getAggregatedData(state) {
    return state.aggregatedData;
  },
  getAnalyticsData(state) {
    return state.analyticsData;
  },
};

const usersAnalyticsDashboard = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default usersAnalyticsDashboard;
